module.exports = __webpack_public_path__ + "img/img53.98a97c81.svg";